import {
  Box,
  Button,
  Skeleton,
  Typography,
  useTheme,
  Divider,
} from '@mui/material';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { useConfig } from '../../api/api';
import moment from 'moment/moment';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../global/theme/tokens';
import WeeklyGrid from './weekly-cal-view/WeeklyGrid';
import ExoCal from './ExoCal';
import { ExoCalSidebar } from './cal/ExoCalSidebar';

const ExoCalWeekView = forwardRef(
  (
    {
      days,
      edit,
      onCancel,
      labelFormat = 'YYYY-MM-DD dddd',
      onSubmit = (e, d) => console.log(e, d),
      snapToGrid = true,
      snapRatio = 3,
      hourStart = 7,
      hourEnd = 18,
      res = 4, //change to adjust hour size
      resHeight = 30,
      userId,
      customColumnLabel,
      onDateClick,
      selectedPeriod,
      onChange,
      onDoubleClick,
      onEventEdit,
      onEventSelect,
      calendars,
      onUpdate,
      useSidebar = true,
      data,
      onClose,
      isDesktop,
      onDelete,
      editMode,
      setEditMode,
      onFeedback,
      setSelectionData,
      onCreateEventInDayView,
      onCloseSidebar,
    },
    ref
  ) => {
    const { t } = useTranslation();
    const config = useConfig();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

    // exposed functions
    useImperativeHandle(ref, () => ({}));

    // expand display hour limit
    const [hourLimit, setHourLimit] = useState({
      start: hourStart,
      end: hourEnd,
    });

    function findHourDisplayLimits() {
      var lowestTime = hourStart;
      var highestTime = hourEnd;

      days.forEach((day) => {
        const events = day?.events;
        events?.forEach((event) => {
          // start
          const timeStart = moment(event.startDateTime);
          const timeStartHour = parseFloat(timeStart.format('H'));
          if (timeStartHour < lowestTime) lowestTime = timeStartHour;

          // end
          const timeEnd = moment(event.endDateTime);
          const timeEndHour = parseFloat(timeEnd.format('H')) + 1;
          if (timeEndHour > highestTime) highestTime = timeEndHour;
        });
      });
      setHourLimit({ start: lowestTime, end: highestTime });
    }

    useEffect(() => {
      if (!days) return;
      findHourDisplayLimits();
    }, [hourStart, hourEnd, days]);

    return (
      <Box className="flex flex-col-reverse md:flex-row h-full w-full gap-2 overflow-hidden pl-[5px] pt-1">
        {/* Main Grid */}
        <div className="flex-grow overflow-hidden">
          <WeeklyGrid
            edit={edit}
            days={days}
            setDays={onChange}
            onCancel={onCancel}
            snapToGrid={snapToGrid}
            snapRatio={snapRatio}
            hourStart={hourLimit.start}
            hourEnd={hourLimit.end}
            res={res}
            resHeight={resHeight}
            labelFormat={labelFormat}
            customColumnLabel={customColumnLabel}
            onDateClick={onDateClick}
            userId={userId}
            onDoubleClick={onDoubleClick}
            onEventEdit={onEventEdit}
            onEventSelect={onEventSelect}
            calendars={calendars}
            onUpdate={onUpdate}
            selectedPeriod={selectedPeriod}
            setSelectionData={setSelectionData}
            useSidebar={useSidebar}
            onCreateEventInDayView={onCreateEventInDayView}
            onClose={onClose}
          />
        </div>

        {/* Right Sidebar */}
        {isDesktop && selectedPeriod === 'day' && (
          <ExoCalSidebar
            data={data}
            calendars={calendars}
            onFeedback={onFeedback}
            onUpdate={onUpdate}
            onDelete={onDelete}
            editMode={editMode}
            onClose={onCloseSidebar}
            setEditMode={setEditMode}
            useSidebar={useSidebar}
          />
        )}
      </Box>
    );
  }
);

export default ExoCalWeekView;
